import React from 'react';
import WidgetMachinesSection from 'components/quote_builder_widget/sections/WidgetMachinesSection';

const DIE_CUTTING_MACHINE_LABELS = {
  add: 'add_die_cutting_machine',
  addTitle: 'add_die_cutting_machine_to_widget',
  select: 'select_die_cutting_machine',
  noneAdded: 'no_die_cutting_machines_enabled',
  noMachines: 'no_die_cutting_machines',
  allAdded: 'all_die_cutting_machines_added',
  notUsed: 'die_cutting_machine_not_used',
  failedToLoad: 'failed_to_load_die_cutting_machines',
  failedToUpdate: 'failed_to_update_die_cutting_machine',
  createNew: 'create_new_die_cutting_machine',
};

const DieCuttingMachinesSection = ({ onDieCuttingMachinesChange, onAddedCountChange }) => (
  <WidgetMachinesSection
    machineKey="die_cutting_machine"
    listUrl="/quote-builder/widgets/die-cutting-machines"
    listField="die_cutting_machines"
    allowedTypesField="accepted_material_groups"
    warningsField="warnings"
    labels={DIE_CUTTING_MACHINE_LABELS}
    onMachinesChange={onDieCuttingMachinesChange}
    onAddedCountChange={onAddedCountChange}
  />
);

export default DieCuttingMachinesSection;
